import { render, staticRenderFns } from "./ModalIregAgreement.vue?vue&type=template&id=8d9e348e&scoped=true&"
import script from "./ModalIregAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalIregAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ModalIregAgreement.vue?vue&type=style&index=0&id=8d9e348e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9e348e",
  null
  
)

export default component.exports